module.exports = __webpack_public_path__ + "static/media/intro.5f45d521.mp3";